import React, { Suspense, lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

// Wave-17 Item 1.1 — Owner DocumentView lazy-loaded (carries react-pdf
// and pdf-lib for the attestation surface — bulky and only ever opened
// from email links).
const DocumentView = lazy(() => import("@/pages/Owner/DocumentView/Container"));

const OwnerTokenView = () => (
  <div className="flex flex-col w-full">
    <Suspense fallback={null}>
      <DocumentView />
    </Suspense>
  </div>
);

export const Route = createFileRoute("/owner/$token")({
  component: OwnerTokenView,
});
